import { render, staticRenderFns } from "./plansDetails.vue?vue&type=template&id=ba3221f6&scoped=true"
import script from "./plansDetails.vue?vue&type=script&lang=js"
export * from "./plansDetails.vue?vue&type=script&lang=js"
import style0 from "./plansDetails.vue?vue&type=style&index=0&id=ba3221f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3221f6",
  null
  
)

export default component.exports